<template>
  <section>
    <h5>{{ book_name }} {{ book.code }}</h5>
    <p v-if="book_author !== '-'">{{ book_author }}</p>
    <p v-if="book_spec != '<p>/</p>'" v-html="book_spec"></p>
    <p v-if="book_intro" v-html="book_intro"></p>
    <social-sharing-button-toolbar
      :title="social_sharing_title"
      :to="social_sharing_route"
    ></social-sharing-button-toolbar><br>
  </section>
</template>

<script>
import Vue from 'vue'

import SocialSharingButtonToolbar from '@/components/button-toolbars/SocialSharingButtonToolbar'

import i18n from '@/plugins/i18n.js'

export default {
  i18n,
  name: 'book-info',
  props: {
    book: {
      type: Object,
      require: true
    }
  },
  computed: {
    book_name() {
      const name = this.$i18n.locale === 'tw' || !this.book.english_name
        ? this.book.chinese_name
        : this.book.english_name
      return `${name} ${this.book.original_name}`.trim()
    },
    book_author() {
      const author = this.$i18n.locale === 'tw' || !this.book.english_author
        ? this.book.chinese_author
        : this.book.english_author
      return `${author} ${this.book.original_author}`.trim()
    },
    book_spec() {
      return this.$i18n.locale === 'tw' || !this.book.english_spec
        ? this.book.chinese_spec
        : this.book.english_spec
    },
    book_intro() {
      return this.$i18n.locale === 'tw' || !this.book.english_intro
        ? this.book.chinese_intro
        : this.book.english_intro
    },
    social_sharing_title() {
      return `${this.book.code} ${this.book_name}`
    },
    social_sharing_route() {
      return { name: 'book', params: { id: this.book.id } }
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
    if (this.book && this.book.id) {
      gtag('event', `browse book`, {
        code: this.book.code,
        name: this.book.chinese_name,
      })
    }
  },
  components: {
    SocialSharingButtonToolbar
  }  
}
</script>